import { IBiLink } from '@suvo-bi-lib'

export const SETTINGS_NAV_LINKS: IBiLink[] = [
  {
    route: 'subscriptions',
    displayName: 'Subscriptions',
    displayIcon: 'payments'
  },
];
